// extracted by mini-css-extract-plugin
module.exports = {"Input":"Select_Input__2glT8","Label":"Select_Label__18a86"};